import React, { useEffect } from 'react';
import TableInc from '../../../../shared-ui/TableInc';
import { trimTimestampFromDate } from '../../../../lib/utils.es6';
import { getPartner, hasAuthourity } from '../../../../lib/access.es6';
import SkeletonWrapper from '../../../NewProductList/components/SkeletonWrapper/SkeletonWrapper';

// Our own debit orders appear here with the debit order's guid as the mandate id; mandates held at the
// partner have numeric ids and have no collections history to open.
const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const Mandates = (props) => {
  if(!props.mandates){
    return
  }


  const currencyCode = getPartner().country.currency_code

  useEffect(() =>{
    props.getMandates(props.msisdn)
  }, [] )

  if (props.mandatesLoader) {
    return <SkeletonWrapper loading={props.mandatesLoader} />
  }

  return (
    <div>
      <h2>Mandates for {props.msisdn} </h2>

      <TableInc
        columns={[
          {
            title: 'Start Date', field: 'startDate', render: rowData => <>
              {
             trimTimestampFromDate(rowData.startDate) || "N/A"
              }
            </>
          },
          {
            title: 'End Date', field: 'endDate', render: rowData => <>
              {
                trimTimestampFromDate(rowData.endDate) || "N/A"
              }
            </>
          },
          {
            title: 'Client Phone', field: 'clientPhone', render: rowData => <>
              {
                rowData.clientPhone || "N/A"
              }
            </>
          },
          {
            title: 'Amount', field: 'amount', render: rowData => <>
              {
               `${currencyCode}  ${rowData.amount}`  || "N/A"
              }
            </>
          },
          {
            title: 'Mandate ID', field: 'mandateId', render: rowData => <>
              {
                rowData.mandateId || "N/A"
              }
            </>
          },
          {
            title: 'Message', field: 'responseMessage', render: rowData => <>
              {
                rowData.responseMessage || "N/A"
              }
            </>
          },

          {
            title: 'Status', field: 'status', render: rowData => <>
              {
                rowData.status || "N/A"
              }
            </>
          },
          {
            title: 'Collections', field: 'mandateId', sorting: false, export: false, render: rowData => (
              GUID.test(rowData.mandateId || '') && hasAuthourity('VIEW_COLLECTIONS')
                ? <a href={`#/admin/collections/order/${rowData.mandateId}`}>Attempts and schedule</a>
                : null
            )
          },
        ]}
        data={props.mandates}
      options={{
        pageSize: props.mandates.length < 5
          ? props.mandates.length
          : 5,
        showTitle: false,
        exportButton: true
      }}

      />
   
    </div>
  );
};

export default Mandates;
